export function createCanvas(size?: { height?: number; width?: number }) {
	const canvas = document.createElement('canvas');
	if (size?.height) {
		canvas.height = size.height;
	}
	if (size?.width) {
		canvas.width = size.width;
	}
	return canvas;
}

export function fillBackgroundColor(canvas: HTMLCanvasElement, color: string) {
	const context = canvas.getContext('2d');
	if (context) {
		context.fillStyle = color;
		context.fillRect(0, 0, canvas.width, canvas.height);
	}
}

export function fillText(
	canvas: HTMLCanvasElement,
	text: string,
	position: { x: number; y: number },
	style?: { fillStyle?: string; font?: string; textAlign?: CanvasTextAlign },
) {
	const context = canvas.getContext('2d');
	if (context) {
		if (style?.fillStyle) {
			context.fillStyle = style?.fillStyle;
		}
		if (style?.font) {
			context.font = style?.font;
		}
		if (style?.textAlign) {
			context.textAlign = style?.textAlign;
		}
		context.fillText(text, position.x, position.y);
	}
}
